/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { MASTER, CALCULATESOLDUNITS, UPDATEPROJECT, ADDPROJECT, SETLOADER, INTERNALMASTER } from './mutation-types';
import storage from '@/services/storageApi';
import store from '@/store';
import _ from 'lodash';

export default {
  [MASTER](state, payload) {
    if (payload.pm) {
      state.projectMaster = payload.pm;
      storage.setSessionData('pm', payload.pm);
    } else {
      state.projectMaster = payload;
      storage.setSessionData('pm', payload);
    }
  },

  [CALCULATESOLDUNITS](state) {
    Object.keys(state.projectMaster).forEach((key) => {
      const project = state.projectMaster[key];
      const unitDetails = project.unit_details;
      const unitMap = unitDetails.unit_type_map;

      unitDetails.sold_units = { TOTAL: 0 };
      unitDetails.total_units = { TOTAL: 0 };
      const soldUnits = unitDetails.sold_units;
      const totalUnits = unitDetails.total_units;

      Object.keys(unitMap).forEach((unitMapKey) => {
        soldUnits[unitMapKey] = unitMap[unitMapKey].filter(unit => unit.sold).length;
        soldUnits.TOTAL += soldUnits[unitMapKey];
        totalUnits[unitMapKey] = unitMap[unitMapKey].length;
        totalUnits.TOTAL += totalUnits[unitMapKey];
      });
    });
  },

  [UPDATEPROJECT](state, payload) {
    if (state.projectMaster) {
      const project = payload;
      let previousProjectStatus = '';
      if (state.projectMaster[project.id])
        previousProjectStatus = state.projectMaster[project.id].auction_status;
      if (previousProjectStatus !== project.auction_status)
        store.dispatch('home/home');
      const unitDetails = project.unit_details;
      const unitMap = unitDetails.unit_type_map;
      if (unitDetails && unitMap) {
        unitDetails.sold_units = { TOTAL: 0 };
        unitDetails.total_units = { TOTAL: 0 };
        const soldUnits = unitDetails.sold_units;
        const totalUnits = unitDetails.total_units;
        Object.keys(unitMap).forEach((unitMapKey) => {
          soldUnits[unitMapKey] = unitMap[unitMapKey].filter(unit => unit.sold).length;
          soldUnits.TOTAL += soldUnits[unitMapKey];
          totalUnits[unitMapKey] = unitMap[unitMapKey].length;
          totalUnits.TOTAL += totalUnits[unitMapKey];
        });
      }
      state.projectMaster[project.id] = project;
    }
  },

  [ADDPROJECT](state, payload) {
    const pm = _.cloneDeep(state.projectMaster);
    if (pm) {
      const project = payload;
      const unitDetails = project.unit_details;
      const unitMap = unitDetails.unit_type_map;
      if (unitDetails && unitMap) {
        unitDetails.sold_units = { TOTAL: 0 };
        unitDetails.total_units = { TOTAL: 0 };
        const soldUnits = unitDetails.sold_units;
        const totalUnits = unitDetails.total_units;
        Object.keys(unitMap).forEach((unitMapKey) => {
          soldUnits[unitMapKey] = unitMap[unitMapKey].filter(unit => unit.sold).length;
          soldUnits.TOTAL += soldUnits[unitMapKey];
          totalUnits[unitMapKey] = unitMap[unitMapKey].length;
          totalUnits.TOTAL += totalUnits[unitMapKey];
        });
      }
      pm[project.id] = project;
    }
    state.projectMaster = _.cloneDeep(pm);
  },

  [SETLOADER](state, payload) {
    state.loader = payload;
  },

  [INTERNALMASTER](state, payload) {
    state.projectMaster[payload.id] = payload;
    storage.setSessionData('pm', state.projectMaster);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/master/mutations.js